import {load,watch,getRef,purify} from './common'

export function loadTags() {
  return load('tags')
}

export function addTag(tag) {
  let {routeId,fbid,key} = tag
  getRef('tags').child(routeId).child(key).child(fbid).set(Date.now())
}

export function deleteTag(tag) {
  let {routeId,fbid,key} = tag
  getRef('tags').child(routeId).child(key).child(fbid).remove()
}



/** WEBPACK FOOTER **
 ** ./src/app/actions/tags.js
 **/